import { Locale } from '~/App/shared/localization/types';

export interface RequestLocaleContext {
  locale: Locale;
}

export interface RequestLocaleStorage {
  getStore(): RequestLocaleContext | undefined;
}

const globalScope = globalThis as typeof globalThis & {
  __kvdRequestLocaleStorage__?: RequestLocaleStorage;
};

export const getRequestLocaleStorage = (): RequestLocaleStorage | undefined =>
  globalScope.__kvdRequestLocaleStorage__;

export const setRequestLocaleStorage = (storage: RequestLocaleStorage) => {
  globalScope.__kvdRequestLocaleStorage__ = storage;
};

export const getCurrentRequestLocale = (): Locale | undefined =>
  getRequestLocaleStorage()?.getStore()?.locale;
